export const EYEBROW = "font-eyebrow text-[11px] font-semibold uppercase tracking-[0.18em] sm:text-xs";
export const fieldClass =
    "h-11 border-[#E8E4DE] bg-[#FFFEF9] pl-11 text-sm font-medium text-[#2D2926] shadow-sm placeholder:text-[#9A9088] focus-visible:border-[#D4AF37]/55 focus-visible:ring-[#D4AF37]/20";
export const labelClass = "text-[11px] font-bold uppercase tracking-[0.12em] text-[#3D2817]";
export const navBtn =
    "border-[#E8E4DE] bg-white text-[#3D2817] shadow-sm hover:border-[#D4AF37]/45 hover:bg-[#FFFEF9]";
export const primaryBtn =
    "h-12 w-full rounded-lg bg-[#4A0E17] text-sm font-semibold tracking-wide shadow-[0_6px_24px_rgba(74,14,23,0.25)] transition-all hover:bg-[#3a0b12] hover:shadow-[0_8px_28px_rgba(74,14,23,0.32)]";

export function formatErr(d) {
    if (!d) return "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
    return d.msg || JSON.stringify(d);
}

export function GoldDivider({ className = "max-w-[200px]" }) {
    return (
        <div className={`flex items-center ${className}`}>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#D4AF37]/80 to-transparent" />
            <span className="px-2.5 text-[10px] leading-none text-[#C9A227]">◆</span>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#D4AF37]/80 to-transparent" />
        </div>
    );
}
